const { shopTheLookProductCache } = window.BAO.Caches
const { getElement } = window.BAO.Utils
const { Cart } = window.BAO

/**
 * @typedef {CustomEvent<{
 *   product: Record<string, unknown>,
 *   variant?: Record<string, unknown>,
 * }>} ShopTheLookProductReplaceEvent
 */

class ShopTheLookProducts extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this._disabled = false
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.submit.element,
      'click',
      this.addAllProducts.bind(this),
    )

    this.listeners.add(
      this,
      'shop-the-look:variant:change',
      this.disableSubmit.bind(this),
    )

    this.listeners.add(
      this,
      'shop-the-look:product:replace',
      this.replaceProduct.bind(this),
    )

    this.listeners.add(
      this,
      'shop-the-look:product:before-add',
      this.handleBeforeAdd.bind(this),
    )
    this.listeners.add(
      this,
      'shop-the-look:product:after-add',
      this.handleAfterAdd.bind(this),
    )
  }

  async addAllProducts () {
    const sectionsToRequest = (() => {
      if (getElement('push-cart')) {
        return window.BAO.sectionRenderer.pushCartSections
      }

      if (getElement('cart-items')) {
        return window.BAO.sectionRenderer.cartSections
      }

      return []
    })()

    for (const element of this.els.form.elements) {
      if (element.dataset.available === 'true') {
        await Cart.addItemFromForm(new FormData(element), {
          sections: sectionsToRequest.map(s => s.section),
        })
      }
    }
  }

  handleBeforeAdd () {
    this.setAttribute('aria-busy', true)

    this.els.product.elements.forEach(element => {
      element.disabled = true
    })
  }

  disableSubmit () {
    let isDisabled = true

    this.els.product.elements.forEach(element => {
      if (
        !element.els.submit.element.disabled &&
        element.els.submit.element.dataset.available === 'true'
      ) {
        isDisabled = false
      }
    })

    this.els.submit.element.disabled = isDisabled
  }

  handleAfterAdd () {
    this.setAttribute('aria-busy', false)

    this.els.product.elements.forEach(element => {
      element.disabled = false
    })
  }

  /** @param {ShopTheLookProductReplaceEvent} event */
  async replaceProduct (event) {
    const { product, variant } = event.detail
    /** @type {HTMLElement} */
    const elementToReplace = event.target

    /**
     * When `variant` is not defined (because one hasn't been selected,
     * for example), we only pass the product handle to the cache
     */
    const cacheKey = [product.handle, variant?.id].filter(Boolean).join('::')

    const replacementHtml = await shopTheLookProductCache.get(cacheKey)
    elementToReplace.outerHTML = replacementHtml
  }
}

if (!window.customElements.get('shop-the-look-products')) {
  window.customElements.define('shop-the-look-products', ShopTheLookProducts)
}
